module.exports = __webpack_public_path__ + "static/media/meh-alt.ef8ff380.svg";